// Toast Helper Functions

export type ToastType = 'success' | 'error' | 'info' | 'warning'

export interface ToastData {
  id: number
  title: string
  text: string
  type: ToastType
}

/**
 * Creates a toast notification object
 * @param title - Toast title
 * @param text - Toast message text
 * @param type - Toast type (success, error, info, warning)
 * @returns ToastData object
 */
export const createToast = (title: string, text: string, type: ToastType = 'info'): ToastData => ({
  id: Date.now(),
  title,
  text,
  type,
})

/**
 * Shows a toast notification by updating state
 * @param title - Toast title
 * @param text - Toast message text
 * @param type - Toast type
 * @returns Toast configuration object for state update
 */
export const showToast = (
  title: string,
  text: string,
  type: ToastType = 'info',
): {toasts: ToastData[]; showToast: boolean} => ({
  toasts: [createToast(title, text, type)],
  showToast: true,
})
